import { NavLink, Outlet } from 'react-router-dom'
import { cn } from 'lib/utils'
import { VENDORS, sortVendors } from 'features/Vendors/vendors'

/**
 * An evaluation's Resources tab (MYD-661): one subtab per vendor app.
 *
 * Every listed vendor gets a subtab, because nothing records yet which vendors
 * an account has integrated. The negative margins cancel the padding of the
 * evaluation's <main>, so the subtabs read as a second row of its tab menu.
 */
const EvaluationResources = () => (
	<div>
		<nav aria-label="Vendor apps" className="-mx-6 -mt-6 mb-4 flex items-center gap-1 border-b border-gray-200 bg-white px-6 py-2">
			{sortVendors(VENDORS).map(vendor => (
				<NavLink
					key={vendor.id}
					to={vendor.id}
					className={({ isActive }) =>
						cn(
							'rounded-full px-3 py-1.5 text-sm no-underline transition-colors',
							isActive
								? 'bg-[#0080fe]/10 font-medium text-[#0080fe]'
								: 'text-gray-600 hover:bg-gray-100 hover:text-gray-900',
						)
					}
				>
					{vendor.name}
				</NavLink>
			))}
		</nav>

		<Outlet />
	</div>
)

export default EvaluationResources
